import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { store } from './context/rootReducer';
import { Provider } from 'react-redux'
import { DndProvider } from 'react-dnd-multi-backend'
import { getBackendOptions } from "@minoru/react-dnd-treeview";

const root = ReactDOM.createRoot(document.getElementById('root'));

const touchOptions = {
  scrollAngleRanges: [
    { start: 30, end: 150 },
    { start: 210, end: 330 }
  ]
}

const html5Options = {
  rootElement: document.body,
  // some options
};
const multiOptions = {
  touch: touchOptions,
  html5: html5Options,
}
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <Provider store={store}>
        <DndProvider options={getBackendOptions(multiOptions)}>
          <App />
        </DndProvider>
      </Provider>
    </AuthContextProvider>
  </React.StrictMode>
);

